import * as Yup from "yup";

export const InternalAssignmentSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Invalid email")
    .required("Email is required"),
});

export const ExternalAssignmentSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Invalid email")
    .required("Email is required"),
  organizationId: Yup.string().required("Organization is required"),
});
